import { createSlice, createSelector } from "@reduxjs/toolkit";
const SCRIPT_NOTIFICATION_FEATURE_KEY = "scriptNotification";
const initialScriptsState = {};
const scriptNotificationSlice = createSlice({
  name: SCRIPT_NOTIFICATION_FEATURE_KEY,
  initialState: initialScriptsState,
  reducers: {
    setScriptsLoaded: (state, action) => {
      const { payload } = action;
      return { ...state, ...payload };
    }
  }
});
const scriptNotificationReducer = scriptNotificationSlice.reducer;
const { setScriptsLoaded } = scriptNotificationSlice.actions;
const getScriptNotificationState = (rootState) => {
  return rootState[SCRIPT_NOTIFICATION_FEATURE_KEY];
};
const selectScriptLoadedState = createSelector(
  getScriptNotificationState,
  (state, scriptName) => scriptName,
  (state, scriptName) => Object.entries(state).reduce((acc, [_, scripts]) => [...acc, ...scripts], []).filter((script) => script.includes(scriptName)).length > 0
);
export {
  SCRIPT_NOTIFICATION_FEATURE_KEY,
  getScriptNotificationState,
  initialScriptsState,
  scriptNotificationReducer,
  scriptNotificationSlice,
  selectScriptLoadedState,
  setScriptsLoaded
};
